<template>
    <div id="main_content" style="padding: 240px 0 5rem 0;">
        <span class="container mt-3 mb-3 title" style="display: flex; align-items: center; justify-content: flex-start">
            {{ mode == 'new' ? t('news.newNews') : t('news.editNews') }}
        </span>
        <!-- <span class="container title" style="font-size: 20px; margin-right: 20px; text-align: right;">
                <input type="checkbox" id="gallery" v-model="isGallery">
                خبر تصویری بوده و در گالری عکس و فیلم نمایش داده خواهد شد
        </span> -->
        <form class="container mt-3 mb-3" style="margin-top: 1rem;" @submit="onSubmit" enctype="multipart/form-data">
            <div style="display: inline-block; width: 60%; margin-left: 1rem;">
                <h3>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="روتیتر"
                        style="font-size: unset;"
                        id="kicker"
                        maxlength="255"
                        v-model="kicker"
                    >
                    <label class="invalid-hint" for="kicker">روتیتر بلند تر از ۲۵۵ حرف مجاز نیست</label>
                </h3>
                <h1>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="تیتر"
                        style="font-size: unset;"
                        id="main_headline"
                        maxlength="1023"
                        v-model="mainHeadline"
                    >
                    <label class="invalid-hint" for="main_headline">تیتر اصلی الزامی بوده لکن تیتر بلند تر از ۱۰۲۳ حرف مجاز نیست</label>
                </h1>
                <h3>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="زیرتیتر"
                        style="font-size: unset;"
                        id="deck"
                        maxlength="2047"
                        v-model="deck"
                    >
                    <label class="invalid-hint" for="deck">زیرتیتر بلند تر از ۲۰۴۷ حرف مجاز نیست</label>
                </h3>
            </div>
            <div style="width: calc(15% - 1rem); float: left;">
                <img :src="chosenPreview" alt="" style="width: auto; height: auto; max-width: 100%; max-height: 14em; margin-bottom: 10px; float: left;">
            </div>
            <div style="width: calc(25% - 2rem); margin-right: 1rem; float: left;">
                <div>
                    <!-- <label for="main_picture_input">تصویر اصلی</label> -->
                    <FileInput
                        text="تصویر اصلی خبر"
                        inpId="main_picture_input"
                        accept="image/png,.jpeg,.jpg"
                        v-model:chosen-preview="chosenPreview"
                        v-model:files="mainPictures"
                        c="green"
                    /> 
                    <label class="invalid-hint" for="main_picture_input">تصویر اصلی الزامی‌ست</label>
                </div>
                <br>
                <div v-if="mode == `new`">
                    <!-- <label for="other_pictures_input">گالری تصویر</label> -->
                    <FileInput
                        text="گالری تصویر (اختیاری)"
                        inpId="other_pictures_input"
                        accept="image/png,.jpeg,.jpg"
                        isMultiple
                        v-model:files="otherPictures"
                        c="brown"
                    />
                    <!-- <label style="margin-top: 10px;">(قابلیت آپلود چند عکس همزمان)</label> -->
                </div>
                <br>
                <div>
                    <FileInput
                        text="ویدیو (حداکثر ۴۰ مگ)"
                        inpId="video_input"
                        accept="video/mp4"
                        v-model:files="video"
                        c="brown"
                    />
                    <label class="invalid-hint" for="video_input">ویدیو اصلی باید حداکثر ۴۰ مگابایت باشد</label>
                </div>
            </div>
            <p class="lead">
                <textarea
                    type="text"
                    class="form-control"
                    placeholder="لید"
                    style="font-size: unset;"
                    rows="2"
                    id="lead"
                    maxlength="4095"
                    v-model="lead"
                ></textarea>
                <label class="invalid-hint" for="lead">لید الزامی بوده لکن لید بلند تر از ۴۰۹۵ حرف مجاز نیست</label>
            </p>
            <span class="container mt-3" style="display: flex; align-items: center; justify-content: flex-start">
                <!-- <input type="checkbox" id="gallery" v-model="isGallery" style="margin-left: 20px;">
                خبر تصویری (و بدون متن) بوده و در گالری عکس و فیلم نمایش داده خواهد شد -->
                <input type="radio" name="isGallery" v-model="isGallery" id="is_not_gallery" value="no" style="margin-left: 10px;">
                <label for="is_not_gallery">خبر متنی</label>
                <input type="radio" name="isGallery" v-model="isGallery" id="is_gallery" value="yes" style="margin-right: 50px; margin-left: 10px;">
                <label for="is_gallery">خبر تصویری (نمایش در گالری عکس و فیلم)</label>
                <input type="radio" name="isGallery" v-model="isGallery" id="is_gallery_and_is_in_normal_news" value="yes_both" style="margin-right: 50px; margin-left: 10px;">
                <label for="is_gallery_and_is_in_normal_news">خبر تصویری (نمایش هم در اخبار هم در گالری عکس و فیلم)</label>
            </span>
            <span class="container mt-3 mb-5" style="display: flex; align-items: center; justify-content: flex-start">
                <input type="radio" name="language" v-model="language" id="is_fa" value="fa" style="margin-left: 10px;">
                <label for="is_fa">خبر فارسی</label>
                <input type="radio" name="language" v-model="language" id="is_ar" value="ar" style="margin-right: 50px; margin-left: 10px;">
                <label for="is_ar">خبر عربی</label>
            </span>

            <WYSIWYG v-if="isGallery == 'no'" v-model:content="content" placeholder="محتوا" id="content" invalidHint="محتوا الزامی است" />
            <label for="topic" class="mt-2">خبر عمومی / مربوط به مدرسه : </label>
            <select id="topic" class="form-select mt-2" v-model="topic">
                <option v-if="hasAccessToTopic('public')" value="public">عمومی (ستاد)</option>
                <option disabled="disabled">_________</option>
                <option v-if="hasAccessToTopic('ali_ibn_musa')" value="ali_ibn_musa">مدرسه علی ابن موسی الرضا (علیهم السلام)</option>
                <option v-if="hasAccessToTopic('karimeh')" value="karimeh">مدرسه کریمه</option>
                <option v-if="hasAccessToTopic('imam_javad')" value="imam_javad">مدرسه امام جواد (علیه السلام)</option>
                <option v-if="hasAccessToTopic('sadr')" value="sadr">مدرسه صدر</option>
                <option v-if="hasAccessToTopic('markaz_qom')" value="markaz_qom">مرکز تخصصی - شعبه قم</option>
                <option v-if="hasAccessToTopic('markaz_tehran')" value="markaz_tehran">مرکز تخصصی - شعبه تهران</option>
                <option v-if="hasAccessToTopic('women_qom')" value="women_qom">مدرسه مشکات اندیشه (خواهران) - شعبه قم</option>
                <option v-if="hasAccessToTopic('women_tehran')" value="women_tehran">مدرسه مشکات اندیشه (خواهران) - شعبه تهران</option>
                <option v-if="hasAccessToTopic('imam_kazem')" value="imam_kazem">مدرسه امام کاظم (علیه السلام)</option>
                <option v-if="hasAccessToTopic('imam_sadeq')" value="imam_sadeq">مدرسه امام صادق (علیه السلام)</option>
                <option disabled="disabled">_________</option>
                <option v-if="hasAccessToTopic('edu')" value="edu">آموزش و پژوهش</option>
                <option v-if="hasAccessToTopic('international')" value="international">بین‌الملل</option>
                <option v-if="hasAccessToTopic('students')" value="students">مشکاتی‌ها</option>
            </select>
            <div style="margin-top: 1rem;">
                <input type="checkbox" id="vin" v-model="vin">
                <label for="vin" style="margin-right: .7rem;">ثبت به عنوان خبر ویژه</label>
                <br>
                <input type="checkbox" id="public" v-model="public" :disabled="$auth.news.validation[mode == 'new' ? 'create' : 'edit'].description != 'public_publish'">
                <label for="public" style="margin-right: .7rem;">نمایش در اخبار عمومی صفحه اول</label>
                <br><br>
                <button type="submit" class="btn btn-green" style="float: left;">{{ mode == "new" ? "ثبت" : "ویرایش" }}</button>
                <a v-if="mode == 'edit'" :href="`/visit/${$route.params.newID}/${mainHeadline}`" class="btn btn-secondary" style="float: left;margin-left: 1rem;">بازگشت</a>
            </div>
        </form>
    </div>
    <div class="loader-bg">
        <h1 v-if="!noAccess">لطفا منتظر بمانید</h1>
        <h1 v-else>شما به این صفحه دسترسی ندارید.<br> ۱۰ ثانیه دیگر به صفحه اصلی باز می‌گردید</h1>
        <span class="loader"></span>
    </div>
</template>

<script>
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import WYSIWYG from '@/components/wysiwyg'
import $ from 'jquery'
import { Delta } from '@vueup/vue-quill'
import FileInput from '@/components/FileInput'
import { useRouter, useRoute } from 'vue-router'
import { useAuth } from '@/authentication'
import { useI18n } from 'vue-i18n'

export default {
    name: "NewNewView",
    components: { WYSIWYG, FileInput },
    mixins: [],
    props: {},
    data: () => ({
        mode: "new",
        kicker: "",
        mainHeadline: "",
        deck: "",
        lead: "",
        content: (new Delta),
        topic: "public",
        vin: false,
        public: false,
        chosenPreview: "",
        mainPictures: [],
        otherPictures: [],
        video: [],
        $router: useRouter(),
        $route: useRoute(),
        $auth: useAuth(),
        noAccess: false,
        isGallery: "no",
        language: "fa",
        t: useI18n().t,
        locale: useI18n().locale
    }),
    methods: {
        onSubmit(e) {
            e.preventDefault();
            const form = e.target
            const values = {
                kicker: this.kicker,
                mainHeadline: this.mainHeadline,
                deck: this.deck,
                lead: this.lead,
                content: this.content,
                topic: this.topic,
                vin: Number(this.vin),
                validation: this.public ? "public" : "special",
                isGallery: this.isGallery,
                language: this.language
            }
            var status = true
            
            if (!this.kickerValidate(values)) { status = false; $('#kicker').addClass('invalid'); $('label.invalid-hint[for="kicker"]').addClass('shown'); }
            else { $('#kicker').removeClass('invalid'); $('label.invalid-hint[for="kicker"]').removeClass('shown'); }

            if (!this.mainHeadlineValidate(values)) { status = false; $('#main_headline').addClass('invalid'); $('label.invalid-hint[for="main_headline"]').addClass('shown'); }
            else { $('#main_headline').removeClass('invalid'); $('label.invalid-hint[for="main_headline"]').removeClass('shown'); }

            if (!this.deckValidate(values)) { status = false; $('#deck').addClass('invalid'); $('label.invalid-hint[for="deck"]').addClass('shown'); }
            else { $('#deck').removeClass('invalid'); $('label.invalid-hint[for="deck"]').removeClass('shown'); }

            if (!this.leadValidate(values)) { status = false; $('#lead').addClass('invalid'); $('label.invalid-hint[for="lead"]').addClass('shown'); }
            else { $('#lead').removeClass('invalid'); $('label.invalid-hint[for="lead"]').removeClass('shown'); }

            if (!this.contentValidate(values)) { status = false; $('#content').addClass('invalid'); $('span.invalid-hint[for="content"]').addClass('shown'); }
            else { $('#content').removeClass('invalid'); $('span.invalid-hint[for="content"]').removeClass('shown'); }

            if (!this.vinValidate(values)) { status = false; }

            if (this.mainPictures.length != 1 && this.mode == "new") { status = false; $('label.invalid-hint[for="main_picture_input"]').addClass('shown'); } 
            else { $('label.invalid-hint[for="main_picture_input"]').removeClass('shown'); }

            if (this.otherPictures.length > 20) { status = false; }

            if (this.video.length > 1 || (this.video[0] && this.video[0].size / 2 ** 20 > 40)) { status = false; $('label.invalid-hint[for="video_input"]').addClass('shown'); }
            else { $('label.invalid-hint[for="video_input"]').removeClass('shown'); }

            if (!["ar","fa"].includes(this.language)) status = false;

            if (!this.isGalleryValidate(values)) { status = false; }

            if (status) {
                // START SENDING REQUEST

                const fd = new FormData();
                const fd2 = new FormData();
                if (this.mode == "edit") values.newID = this.$route.params.newID;
                for (const key in values) {
                    if (Object.hasOwnProperty.call(values, key) && key != 'content') {
                        const value = values[key];
                        fd.append(key, value);
                    }
                }
                if (this.mainPictures.length == 1) fd.append("main_picture", this.mainPictures[0]);
                if (this.video.length == 1) fd.append("video", this.video[0]);
                
                // Sending other pictures should be in another request.
                for (const key in this.otherPictures) {
                    if (Object.hasOwnProperty.call(this.otherPictures, key)) {
                        const picture = this.otherPictures[key];
                        fd2.append(`other_pictures[${key}]`, picture);
                    }
                }
                
                fd.append("content", JSON.stringify(values.content.ops));
                // values.content = values.content.ops


                const keyword = this.mode == "new" ? "ثبت" : "ویرایش"
                const mode = this.mode;
                const $router = this.$router;
                const $route = this.$route;

                $.ajax({
                    url: `${process.env.VUE_APP_SERVER_ROOT}` + (mode == "new" ? "new-new" : "edit-new"),
                    method: "POST",
                    xhrFields: {
                        withCredentials: true
                    },
                    data: fd,
                    dataType: "json",
                    contentType: false,
                    processData: false,
                    beforeSend() {
                        $('.loader-bg').css({ display: 'flex' })
                    },
                    success(data) {
                        $('.loader-bg').css({ display: 'none' })
                        if (!data.STATUS) {
                            alert(`خطا در ${keyword} خبر! ${data.REASON}`)
                        } else if (mode == 'new') {
                            if (data.VIDEO_COULD_NOT_UPLOAD) {
                                alert("ثبت فیلم ممکن نبود.")
                            }
                            $.ajax({
                                url: `${process.env.VUE_APP_SERVER_ROOT}other-pictures/${data.INSERT_ID}/` + (mode == "new" ? "new-new" : "edit-new"),
                                method: "POST",
                                xhrFields: {
                                    withCredentials: true
                                },
                                data: fd2,
                                dataType: "json",
                                contentType: false,
                                processData: false,
                                beforeSend() {
                                    $('.loader-bg').css({ display: 'flex' })
                                },
                                success(data2) {
                                    $('.loader-bg').css({ display: 'none' })
                                    if (!data2.STATUS) {
                                        alert(`${keyword} عکس های فرعی موفقیت آمیز نبود زیرا «` + data2.REASON + "»");
                                    } else {
                                        alert(`${keyword} موفقیت آمیز بود`);
                                        $router.push(`${$route.params.locale ? `/${$route.params.locale}` : ''}/visit/` + (mode == "edit" ? values.newID : data.INSERT_ID) + '/' + values.mainHeadline.replaceAll(` `, `-`))
                                    }
                                },
                                error() {
                                    $('.loader-bg').css({ display: 'none' })
                                    alert("ارسال عکس های فرعی موفقیت آمیز نبود")
                                    $router.push(`${$route.params.locale ? `/${$route.params.locale}` : ''}/visit/` + (mode == "edit" ? values.newID : data.INSERT_ID) + '/' + values.mainHeadline.replaceAll(` `, `-`))
                                }
                            })
                            // location.href = `/visit/` + (mode == "edit" ? values.newID : data.INSERT_ID) + '/' + values.mainHeadline
                        } else {
                            $router.push(`${$route.params.locale ? `/${$route.params.locale}` : ''}/visit/` + (mode == "edit" ? values.newID : data.INSERT_ID) + '/' + values.mainHeadline.replaceAll(` `, `-`))
                        }
                    },
                    error() {
                        $('.loader-bg').css({ display: 'none' })
                        alert("ارسال اطلاعات موفقیت آمیز نبود")
                    }
                })
            }
        },
        // formValues() {
        //     return {
        //         kicker: $('#kicker').val(),
        //         mainHeadline: $('#main_headline').val(),
        //         deck: $('#deck').val(),
        //         lead: $('#lead').val(),
        //         content: (this.content && this.content.ops) ? this.content.ops : {}
        //     }
        // },
        kickerValidate(values)          { return values.kicker.length < 256 },
        mainHeadlineValidate(values)    { return values.mainHeadline && values.mainHeadline.length < 1024 },
        deckValidate(values)            { return values.deck.length < 2048 },
        leadValidate(values)            { return values.lead && values.lead.length < 4096 },
        contentValidate(values)         { return values.isGallery != 'no' || (values.content && values.content.length()) },
        vinValidate(values)             { return values.vin == 1 || values.vin == 0 },
        isGalleryValidate(values)       { return !!["no","yes","yes_both"].filter(n => n == values.isGallery).length },

        hasAccessToTopic(topic) {
            return !!this.$auth.news.levelOfAccess.filter(n => n.description == topic).length
        }
    },
    computed: {

    },
    created() {
        if (this.$route.params.newID) {
            // ON EDIT PAGE
            this.mode = "edit"
            const newID = this.$route.params.newID

            const vueApp = this;

            $.ajax({
                url: `${process.env.VUE_APP_SERVER_ROOT}visit-new/${newID}`,
                method: "GET",
                dataType: "json",
                xhrFields: {
                    withCredentials: true
                },
                success(data) {
                    if (data.STATUS) {
                        vueApp.kicker = data.KICKER;
                        vueApp.mainHeadline = data.MAIN_HEADLINE;
                        vueApp.deck = data.DECK;
                        vueApp.lead = data.LEAD;
                        vueApp.content = new Delta(data.CONTENT);
                        vueApp.vin = data.VIN;
                        vueApp.chosenPreview = `${process.env.VUE_APP_SERVER_ROOT}picture/${data.PICTURES.main}`
                        vueApp.topic = data.TOPIC;
                        vueApp.public = data.PUBLIC;
                        vueApp.isGallery = data.IS_GALLERY;
                        vueApp.language = data.LANGUAGE ?? 'fa';

                        if (!vueApp.$auth.news.levelOfAccess.filter(n => n.description == vueApp.topic).length) {
                            // ON INVALID EDIT PAGE
                            vueApp.noAccess = true;
                            $('.loader-bg').css({ display: 'flex' })
                            setTimeout(() => { location.href = "/" }, 10*10**3)
                        }
                    } else {
                        alert("دریافت اطلاعات موفقیت آمیز نبود زیرا " + data.REASON)
                    }
                },
                error() {
                    alert("دریافت اطلاعات موفقیت آمیز نبود")
                }
            })
        }
    },
    mounted() {
        if (this.$route.params.locale) this.locale = this.$route.params.locale
    }
}

</script>

<style scoped lang="less">

h2 {
    font-size: 2.3em;
}
h3 {
    font-size: 1.6em;
}
.lead {
    font-size: 1em;
    margin-bottom: .5rem;
    width: 100%;

    textarea {
        resize: vertical;
    }
}

.loader-bg {
    width: 100vw;
    height: 100vh;
    top:0;right:0;bottom:0;left:0;
    position: fixed;
    display: none;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    background: #0008;
    backdrop-filter: blur(10px);

    h1 {
        color: white;
    }
}

.loader, .loader:before, .loader:after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: bblFadInOut 1.8s infinite ease-in-out;
    top: -1.25em;
    // top: -1px!important;
}
.loader {
    color: #FFF;
    font-size: 7px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
}
.loader:before,
.loader:after {
    content: '';
    position: absolute;
    top: 0;
}
.loader:before {
    left: -3.5em;
    animation-delay: -0.32s;
}
.loader:after {
    left: 3.5em;
}

@keyframes bblFadInOut {
    0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em }
    40% { box-shadow: 0 2.5em 0 0 }
}

</style>

<style lang="less">

.form-control {
    transition: border-color .2s ease-in-out;
    &.invalid {
        border-color: red;
    }
}

.invalid-hint {
    display: none;
    font-size: .7rem;
    color: red;
    font-weight: bold;
    margin: .2rem .5rem .7rem .5rem;

    &.shown {
        display: block;
    }
}

</style>